import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'mc-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavItemComponent {
  @Input() label: string;
  @Input() link?: string;
  @Input() icon?: string;
  @Input() isActive?: boolean = false;
  @Input() iconActive?: string;
  @Input() labelIcon?: string;
  @Input() labelIconActive?: string;

  @Output() navigate = new EventEmitter();

  constructor() {}

  public onNavigate() {
    this.navigate.emit();
  }
}
